import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { 
  Users, 
  Receipt, 
  Target, 
  BookOpen, 
  ArrowLeftRight, 
  PieChart,
  ChevronRight,
  CreditCard,
  DollarSign
} from 'lucide-react';
import { FinancePageLayout } from '@/components/finance';

const SETTINGS_SECTIONS = [
  {
    title: 'Funcionários',
    description: 'Gerenciar funcionários, salários e alocações de custo',
    href: '/people/employees',
    icon: Users,
    color: 'text-blue-600 bg-blue-100',
  },
  {
    title: 'Despesas Recorrentes',
    description: 'Configurar despesas fixas mensais e anuais',
    href: '/finance/settings/recurring',
    icon: Receipt,
    color: 'text-orange-600 bg-orange-100',
  },
  {
    title: 'Metas e Indicadores',
    description: 'Definir KPIs e metas financeiras por período',
    href: '/finance/settings/kpis',
    icon: Target,
    color: 'text-green-600 bg-green-100',
  },
  {
    title: 'Plano de Contas',
    description: 'Visualizar e configurar a estrutura de contas',
    href: '/finance/settings/chart-of-accounts',
    icon: BookOpen,
    color: 'text-purple-600 bg-purple-100',
  },
  {
    title: 'Câmbio',
    description: 'Gerenciar taxas de câmbio entre moedas',
    href: '/finance/settings/exchange-rates',
    icon: ArrowLeftRight,
    color: 'text-teal-600 bg-teal-100',
  },
  {
    title: 'Análise Fixo vs Variável',
    description: 'Classificar e analisar custos fixos e variáveis',
    href: '/finance/settings/cost-analysis',
    icon: PieChart,
    color: 'text-pink-600 bg-pink-100',
  },
  {
    title: 'Limpeza Stripe',
    description: 'Identificar e unificar clientes duplicados no Stripe',
    href: '/finance/settings/stripe-cleanup',
    icon: CreditCard,
    color: 'text-indigo-600 bg-indigo-100',
  },
  {
    title: 'Regras de Comissão',
    description: 'Configurar planos de comissão com tiers, aceleradores e ramp-up',
    href: '/finance/comissoes',
    icon: DollarSign,
    color: 'text-emerald-600 bg-emerald-100',
  },
];

export default function FinanceSettings() {
  return (
    <FinancePageLayout>
      <h1 className="text-2xl font-bold tracking-tight">Configurações Financeiras</h1>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {SETTINGS_SECTIONS.map((section) => {
          const Icon = section.icon;
          
          return (
            <Link key={section.href} to={section.href}>
              <Card className="h-full hover:bg-muted/50 transition-colors cursor-pointer group">
                <CardHeader className="flex flex-row items-start gap-4">
                  <div className={`p-3 rounded-lg ${section.color}`}>
                    <Icon className="h-6 w-6" />
                  </div>
                  <div className="flex-1">
                    <CardTitle className="flex items-center justify-between">
                      {section.title}
                      <ChevronRight className="h-5 w-5 text-muted-foreground group-hover:text-foreground transition-colors" />
                    </CardTitle>
                    <CardDescription className="mt-1">
                      {section.description}
                    </CardDescription>
                  </div>
                </CardHeader>
              </Card>
            </Link>
          );
        })}
      </div>
    </FinancePageLayout>
  );
}
